
import axiosInstance from "../utils/api";

import endpoints from '../constants/endpoints';

export  const OrderEndpoints = {
    fetchListOfOrdersAdmin : async () => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchListOfOrders}`);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to fetch orders: ' + error.message);
        }
    },
    searchAndFilterOrders: async (payload) => {
        try {
            const response = await axiosInstance.post(`${endpoints.searchAndFilterOrders}`, payload);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to fetch orders: ' + error.message);
        }
    },

    fetchSingleOrderDetailAdmin: async (orderUid) => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchSingleOrderDetail(orderUid)}`);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to fetch order details: ' + error.message);
        }
    }
    ,
    updateOrderStatus: async (orderUid, payload) => {
        try {
            const response = await axiosInstance.put(`${endpoints.updateOrderStatus(orderUid)}`, payload);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to update order status: ' + error.message);
        }
    },

    userOrderHistory: async () => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchUserOrderHistory}`);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to fetch orders: ' + error.message);
        }
    },
    userOrderHistorySearchAndFilter: async (formData) => {
        try {
            const response = await axiosInstance.post(`${endpoints.searchAndFilterUserOrderHistory}`, formData);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to fetch orders: ' + error.message);
        }
    },
    fetchTrackOrderStatus: async (orderid) => {
        try {
            const response = await axiosInstance.get(`${endpoints.trackOrderStatus(orderid)}`);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to fetch order details: ' + error.message);
        }
    },
    addOrUpdateUserFeedbackForOrder: async (orderUid, formData) => {
        try {
            const response = await axiosInstance.post(`${endpoints.addOrUpdateUserOrderFeedback(orderUid)}`, formData);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to update order status: ' + error.message);
        }
    },
    userMarkOrderAsReviewed: async (orderId) => {
        try {
            const response = await axiosInstance.post(`${endpoints.userMarkProductAsDelivered(orderId)}`);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to update order status: ' + error.message);
        }
    },
    deleteOrderAdmin: async (orderUids) => {
        const response = await axiosInstance.delete(`${endpoints.deleteOrders}`, { data: { order_uids: orderUids } });
        return response.data; 
    }
    
}
